import { validateEmail } from '@revenuemarket/utils';
import * as yup from 'yup';

import { CalculatorFormData } from '~apis/estimate-calculate';

export const formatNumber = (num?: string | number) => {
  if (num === undefined) return num;

  const number = Number(num);

  return isNaN(number) ? num : number.toLocaleString();
};

export const parseNumber = (num?: string | number | boolean) => {
  if (num === undefined) return '';

  const number = Number(num.toString().replace(/\D/g, ''));

  return isNaN(number) ? num : number.toString();
};

export const CALCULATOR_FORM_SCHEME: yup.SchemaOf<CalculatorFormData> = yup.object({
  userName: yup.string().required('이름을 입력해주세요.'),
  companyName: yup.string().required('회사명을 입력해주세요.'),
  userPosition: yup.string().required('직함을 입력해주세요.'),
  email: yup
    .string()
    .required('이메일을 입력해주세요.')
    .test('format', '이메일 형식에 맞춰 입력해주세요.', (value) => {
      if (value) {
        return validateEmail(value);
      }
      return false;
    }),
  monthlyAverageRevenue: yup.number().required('월평균 매출을 입력해주세요.'),
  monthlyAverageSpend: yup.number().required('월평균 비용을 입력해주세요.'),
  cashAtHand: yup.number().required('현재 보유 현금을 입력해주세요.'),
  agreeToPersonalInfoCollection: yup.boolean().required().oneOf([true]),
  agreeToEmailMarketing: yup.boolean().required(),
});
